export default function AboutFourModels() {
  const stats = [
    { icon: 'ri-trophy-fill', value: '38+', label: 'Anos de mercado' },
    { icon: 'ri-global-fill', value: '100+', label: 'Modelos no mercado internacional' },
    { icon: 'ri-star-fill', value: '1ª', label: 'Top model brasileira lançada' },
    { icon: 'ri-film-fill', value: 'TV & Moda', label: 'Atores e modelos nas maiores emissoras' }
  ];

  const highlights = [
    { icon: 'ri-award-fill', text: 'Dirigida por Marla Drebes, referência nacional e internacional na descoberta de talentos.' },
    { icon: 'ri-book-fill', text: 'Marla Drebes está no RankBrasil em 2004, é a Primeira brasileira a descobrir e projetar uma top model made in Brasil: Shirley Mallmann foi lançada em janeiro de 1995.' },
    { icon: 'ri-user-star-fill', text: 'Responsável por lançar Shirley Mallmann — a primeira top model brasileira no cenário internacional.' },
    { icon: 'ri-flashlight-fill', text: 'Revelou talentos como Jeisa Chiminazzo e diversos nomes que atuam no Brasil e no exterior.' },
    { icon: 'ri-movie-2-fill', text: 'Trabalha também com atores, conectando talentos a testes nas maiores emissoras do país.' },
    { icon: 'ri-medal-fill', text: 'Histórico de grandes projetos e recordes nacionais no segmento da moda.' }
  ];

  const scrollToForm = () => {
    const element = document.getElementById('inscricao');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-14 sm:py-20 lg:py-28 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-yellow-500/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        <div className="text-center mb-10 sm:mb-14 lg:mb-16">
          <p className="text-xs font-bold text-yellow-600 tracking-widest uppercase mb-3">
            Tradição · Credibilidade · Resultados
          </p>
          <h4 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-black mb-3">
            <a href="#autoridade">
              Quem Está Por Trás da <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">Four Models?</span>
            </a>
          </h4>
          <p className="text-sm sm:text-base lg:text-lg text-gray-500 max-w-2xl mx-auto">
            Mais de três décadas transformando vidas e lançando carreiras no mercado da moda e do entretenimento.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5 lg:gap-6 mb-10 sm:mb-14 lg:mb-16">
          {stats.map((stat, idx) => (
            <div key={idx} className="bg-black rounded-2xl p-4 sm:p-7 lg:p-8 text-center border border-yellow-500/20 hover:border-yellow-500 transition-all duration-300 cursor-pointer group">
              <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${stat.icon} text-base sm:text-xl lg:text-2xl text-black`}></i>
              </div>
              <p className="text-xl sm:text-3xl lg:text-4xl font-black text-yellow-500 mb-1">{stat.value}</p>
              <p className="text-gray-400 text-xs lg:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="bg-black rounded-2xl p-5 sm:p-10 lg:p-12 border border-yellow-500/20 mb-8 sm:mb-10 lg:mb-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">
            {highlights.map((item, idx) => (
              <div key={idx} className="flex items-start gap-3 sm:gap-4">
                <div className="w-9 h-9 lg:w-10 lg:h-10 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${item.icon} text-sm sm:text-base text-black`}></i>
                </div>
                <p className="text-gray-300 text-sm lg:text-base leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <button onClick={scrollToForm} type="button" className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-8 sm:px-10 lg:px-16 py-3.5 sm:py-4 lg:py-5 rounded-full text-sm lg:text-base font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto">
            GARANTIR MINHA VAGA
          </button>
        </div>
      </div>
    </section>
  );
}